/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/


import React from 'react'
import { useState, useEffect } from 'react';
import Button from 'Admin/elements/CustomButton/CustomButton.jsx';
import * as API from 'Front/api/emr';
import { Modal, FormGroup } from 'react-bootstrap';

const DiagnosisFilterModal = ({ showDiagnosisModal, handleClose, diagnosisEnlarge, setDiagnosisEnlarge, diagnosisCategoryList, handleDiagnosisType, handleSaveDiagnosisFilter, filters }) => {
    const [rowsLongTerm, setRowsLongTerm] = useState(filters ? filters?.filter((obj) => obj.diagnosisType === "longTerm") : []);
    const [rowsInterCurrent, setRowsInterCurrent] = useState(filters ? filters?.filter((obj) => obj.diagnosisType === "intercurrent") : []);
    const [diagnosisSubcategoryList, setDiagnosisSubcategoryList] = useState([]);
    const [diagnosisCount, setDiagnosisCount] = useState(false)
    const [flag, setFlag] = useState("");


    const clinicId = localStorage.getItem("clinicId")



    let diagnosisCategoryId = diagnosisEnlarge.diagnosisCategoryId
    let arrSubCategoryCheked = []

    const getDiagnosisSubCategory = async (e, catType) => {

        let type = "longTerm"
        let radioCategory = document.getElementById("longTermEnlarge")
        if (radioCategory !== null) {
            type = radioCategory.checked === true ? "longTerm" : "intercurrent"
        }
        setDiagnosisSubcategoryList([])

        if (e)
            diagnosisCategoryId = e.target.id
        activateTab(diagnosisCategoryId)

        let req = ""

        // if (catType === "master") {
        //     req = {
        //         "type": type,
        //         "diagonsisCategoryId": diagonsisCategoryId,
        //         "patientId": patientId,
        //         "clinicId": clinicId
        //     }

        // } else if (catType === "patient") {
        //     req = {
        //         "type": type,
        //         "diagonsisCategoryId": "",
        //         "patientId": patientId,
        //         "clinicId": ""
        //     }
        // } else 

        if (catType === "clinic") {
            req = {
                "type": type,
                "diagonsisCategoryId": "",
                "patientId": "",
                "clinicId": clinicId
            }

        } else if (catType === "category") {
            req = {
                "type": type,
                "diagonsisCategoryId": diagnosisCategoryId,
                "patientId": "",
                "clinicId": ""
            }
        }


        let resp = await API.diagonsisList(req);
        if (resp.data && resp.data.status === "Success") {
            setFlag(resp.data.flag)
            // if (resp.data.flag === "patientDiagonsisList") {
            //     let radioPatient = document.getElementById(patientId);
            //     if (radioPatient !== null)
            //         radioPatient.checked = true;
            //     if (resp.data.patientDiagonsisList.length > 0) {
            //         setDiagnosisSubcategoryList(resp.data.patientDiagonsisList)
            //         arrSubCategoryCheked = resp.data.patientDiagonsisList
            //     }
            // } else 

            if (resp.data.flag === "clinicDiagonsisList") {
                let radioClinic = document.getElementById(clinicId);
                if (radioClinic !== null)
                    radioClinic.checked = true;
                if (resp.data.clinicDiagonsisList.length > 0) {
                    setDiagnosisSubcategoryList(resp.data.clinicDiagonsisList)
                    arrSubCategoryCheked = resp.data.clinicDiagonsisList
                }
            } else if (resp.data.flag === "masterDiagonsisCategoryList") {
                if (resp.data.masterDiagonsisCategoryList.data.length > 0) {
                    setDiagnosisSubcategoryList(resp.data.masterDiagonsisCategoryList.data)
                    arrSubCategoryCheked = resp.data.masterDiagonsisCategoryList.data
                }
            }

            selectSubcategory(resp.data.flag)
        }
    }

    const selectSubcategory = (flagList) => {
        let tempArr = []
        let radioCategory = document.getElementById("longTermEnlarge");
        if (radioCategory !== null) {
            tempArr = radioCategory.checked === true ? rowsLongTerm : rowsInterCurrent
            tempArr.map(item => {
                if (arrSubCategoryCheked.length > 0) {
                    arrSubCategoryCheked.map(subcat => {
                        if (flagList === "patientDiagonsisList") {
                            if (subcat.diagonsisSubCategoryId === item.diagnosisSubCategoryId) {
                                checkedComplaint(subcat.diagonsisSubCategoryId)
                            }
                        } else {
                            if (subcat._id === item.diagnosisSubCategoryId) {
                                checkedComplaint(subcat._id)
                            }

                        }
                    })
                }
            })
        }

    }


    const checkedComplaint = (subcatId) => {
        let chkSubCategory = document.getElementsByName("subcat");
        for (var subCategory of chkSubCategory) {
            if (subcatId === subCategory.getAttribute("subcatid")) {
                subCategory.checked = true;
            }
        }
    }

    const activateTab = (id) => {
        let listDiagnosisCatgeory = document.getElementsByName("diagnosisCategoryName");
        setDiagnosisEnlarge({ ...diagnosisEnlarge, diagnosisCategoryId: id })
        for (var category of listDiagnosisCatgeory) {

            if ("cat" + id === category.getAttribute("id")) {
                category.classList.add('current')
            } else {
                category.classList.remove('current')
            }

        }
    }

    const addOrDeleteSubcategory = (e, itm) => {
        console.log(itm, "----itm")
        setDiagnosisCount(false)
        let type = "longTerm"
        let radioCategory = document.getElementById("longTermEnlarge");
        if (radioCategory !== null) {
            type = radioCategory.checked === true ? "longTerm" : "intercurrent"
        }


        if (e.target.checked) {
            let diagnosisCategoryName = itm?.clinicId ? "My Clinic" : itm?.diagonsisCategoryName
            if (type === "longTerm") {
                rowsLongTerm.push({
                    diagnosisSubCategoryId: e.target.getAttribute("subcatid"),
                    diagnosisSubCategoryName: e.target.value,
                    value: `${e.target.value}-(${diagnosisCategoryName})`,
                    diagnosisType: type,
                    diagnosisCategoryId: itm?.diagonsisCategoryId
                })

                setRowsLongTerm([...rowsLongTerm])

            } else {
                rowsInterCurrent.push({
                    diagnosisSubCategoryId: e.target.getAttribute("subcatid"),
                    diagnosisSubCategoryName: e.target.value,
                    value: `${e.target.value}-(${diagnosisCategoryName})`,
                    diagnosisType: type,
                    diagnosisCategoryId: itm?.diagonsisCategoryId
                })
                setRowsInterCurrent([...rowsInterCurrent])

            }
        } else {
            deleteDiagnosis(e, type)
        }
    }

    const deleteDiagnosis = (e, type) => {

        let subCatId = e.target.getAttribute("subcatid");


        let chkbox_subact = document.getElementsByName("subcat");
        for (var chk of chkbox_subact) {
            if (chk.getAttribute("subcatid") === subCatId) {
                chk.checked = false;
            }
        }
        if (type === "longTerm") {
            rowsLongTerm.map((itm, idx) => {
                if (itm.diagnosisSubCategoryId === subCatId) {
                    rowsLongTerm.splice(idx, 1);
                    return;
                }
            })

        } else {
            rowsInterCurrent.map((itm, idx) => {
                if (itm.diagnosisSubCategoryId === subCatId) {
                    rowsInterCurrent.splice(idx, 1);
                    return;
                }
            })

        }
        setRowsLongTerm([...rowsLongTerm]);
        setRowsInterCurrent([...rowsInterCurrent]);

    }

    const submitHandler = (e) => {
        e.preventDefault();
        if (rowsLongTerm.length > 0 || rowsInterCurrent.length > 0) {
            let updatedFilters = [
                ...rowsLongTerm.map((ele) => ({ ...ele, category: "Diagnosis", id: ele?.diagnosisSubCategoryId })),
                ...rowsInterCurrent.map((ele) => ({ ...ele, category: "Diagnosis", id: ele?.diagnosisSubCategoryId }))
            ];

            console.log(updatedFilters, "lllllllllll")
            handleSaveDiagnosisFilter(updatedFilters)
        } else {
            setDiagnosisCount(true);
        }
    };

    useEffect(() => {
        console.log(filters, "----filters")
        const timer = setTimeout(() => {
            let catType = diagnosisEnlarge.diagnosisCategoryId === clinicId ? "clinic" : "category"
            getDiagnosisSubCategory("", catType)
        }, 100);

        return () => clearTimeout(timer);
    }, [])

    useEffect(() => {
        let catType = diagnosisEnlarge.diagnosisCategoryId === clinicId ? "clinic" : "category"
        getDiagnosisSubCategory("", catType)
    }, [diagnosisEnlarge.type])

    return (
        <>
            <Modal className='suggestion-box-modal' show={showDiagnosisModal} onHide={handleClose} dialogClassName="modal-xl">
                <Modal.Header closeButton className="bg-thumbcolor">
                    <Modal.Title id="example-modal-sizes-title-lg">Diagnosis</Modal.Title>
                </Modal.Header>
                <Modal.Body className="suggetion-box-enlarge">

                    <div className="system-lists">
                        <FormGroup className="">
                            <div style={{ paddingRight: "10px", width: "auto" }} className="form-check form-check-emr form-check-inline">
                                <input className="form-check-input" type="radio" name="catTypeEnlarge" onClick={() => { handleDiagnosisType("longTerm"); }} id="longTermEnlarge" value="value1" checked={diagnosisEnlarge.type === "longTerm"} />
                                <label className="form-check-label" for="longTermEnlarge">Long term </label>
                            </div>
                            <div style={{ paddingRight: "0px", width: "auto" }} className="form-check form-check-emr form-check-inline">
                                <input className="form-check-input" type="radio" name="catTypeEnlarge" onClick={() => { handleDiagnosisType("intercurrent"); }} id="intercurrentEnlarge" value="value2" checked={diagnosisEnlarge.type === "intercurrent"} />
                                <label className="form-check-label" for="intercurrentEnlarge">Intercurrent</label>
                            </div>
                        </FormGroup>
                        <h5>Systems</h5>

                        <ul>
                            {/* <li name="diagnosisCategoryName" id={"cat" + patientId}><a id={patientId} onClick={(e) => { getDiagnosisSubCategory(e, "patient"); }}>Patient List</a></li> */}
                            <li name="diagnosisCategoryName" id={"cat" + clinicId}><a id={clinicId} onClick={(e) => { getDiagnosisSubCategory(e, "clinic"); }}>My List</a></li>
                            {diagnosisCategoryList.map(item => {
                                return (<>
                                    <li id={"cat" + item._id} name="diagnosisCategoryName" className=''><a id={item._id} onClick={(e) => { getDiagnosisSubCategory(e, "category") }}>{item.name}</a></li>
                                </>)
                            })
                            }

                        </ul>

                    </div>
                    <div className="suggestion-lists">
                        <div className="selected-complaints">
                            <div className='selected-complaint-left'>
                                {diagnosisCount &&
                                    <div >
                                        <p style={{ 'color': 'red' }}>There is no data to add</p>
                                    </div>
                                }
                                <h5>Diagnosis Selected</h5>
                                <ul>
                                    {rowsLongTerm.map(item => {
                                        return (<>
                                            <li name="" style={{ background: '#830707', marginBottom: '8px' }} className=''><a id={item.diagnosisSubCategoryId} style={{ color: '#fff' }}  >{item.diagnosisSubCategoryName}</a>
                                                <span style={{ color: '#fff', cursor: "pointer" }} onClick={(e) => { deleteDiagnosis(e, "longTerm") }} subcatid={item.diagnosisSubCategoryId} id={item.diagnosisSubCategoryId} >x</span>
                                            </li>
                                        </>)
                                    })
                                    }
                                    {rowsInterCurrent.map(item => {
                                        return (<>
                                            <li name="" style={{ background: 'green', marginBottom: '8px' }} className=''><a id={item.diagnosisSubCategoryId} style={{ color: '#fff' }} >{item.diagnosisSubCategoryName}</a>
                                                <span style={{ color: '#fff', cursor: "pointer" }} onClick={(e) => { deleteDiagnosis(e, "intercurrent") }} subcatid={item.diagnosisSubCategoryId} id={item.diagnosisSubCategoryId} >x</span>
                                            </li>

                                        </>)
                                    })
                                    }

                                </ul>
                            </div>
                            <div className='text-right'>
                                <Button className="btn btn-primary btn-fill custom-btn-style" onClick={e => submitHandler(e)}>Add</Button>
                            </div>
                        </div>
                        <div className="suggestion-list">
                            {diagnosisSubcategoryList.map(item => {
                                return (<>
                                    <div class="form-check">
                                        <input class="form-check-input" name="subcat" type="checkbox" onChange={(e) => { addOrDeleteSubcategory(e, item); }} value={flag === "masterDiagonsisCategoryList" ? item.name : item.diagonsisSubCategoryName} subcatid={flag === "patientDiagonsisList" ? item.diagonsisSubCategoryId : item._id} id={`subcatdiagnosis${flag === "patientDiagonsisList" ? item.diagonsisSubCategoryId : item._id}`} />
                                        <label class="form-check-label" for={`subcatdiagnosis${flag === "patientDiagonsisList" ? item.diagonsisSubCategoryId : item._id}`}>
                                            {flag === "masterDiagonsisCategoryList" ? item.name : item.diagonsisSubCategoryName}
                                        </label>
                                    </div>
                                </>
                                )
                            })
                            }
                        </div>

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default DiagnosisFilterModal